/**
 * SdefBufferKind Constants
 */
export class SdefBufferKind {
    static MatricesSdefCKind = "matricesSdefC";
    static MatricesSdefR0Kind = "matricesSdefR0";
    static MatricesSdefR1Kind = "matricesSdefR1";
}
